import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/Splatter.svg'


const _hoisted_1 = {
  id: "header",
  class: "mx-auto flex max-w-3xl items-center justify-between py-1.5"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-start gap-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "40",
    height: "auto"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-left font-bold leading-none" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createTextVNode("Fully"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("On-chain")
    ])
  ])
], -1)
const _hoisted_3 = {
  id: "nav",
  class: "flex flex-wrap items-center justify-start"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Splatter ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Bitcoin ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Alphabet ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Snow ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Star ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Nouns ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Sample ")
const _hoisted_11 = { class: "invisible" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Languages = _resolveComponent("Languages")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/'),
        class: "text-md"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("header.home")), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/splatter'),
        class: "text-md"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/bitcoin'),
        class: "text-md"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/alphabet'),
        class: "text-md"
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/snow'),
        class: "text-md"
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/star'),
        class: "text-md"
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/nouns'),
        class: "text-md"
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/sample'),
        class: "text-md"
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_Languages)
    ])
  ]))
}